import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Typography, Modal, Input, List, Collapse } from 'antd'
import {
  CaretRightOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons'
import { FlexSectionHeader } from '../style'
import CourseCard from '../../components/CourseCard'

import Spinner from '../../components/Spinner'

import {
  getAllCourses,
  deleteCourse,
  enroll,
  unEnroll
} from '../../reducers/courseReducer'

import { useHistory } from 'react-router-dom'
import { getAllAdminCourses } from '../../reducers/adminReducer'

const { Title, Text } = Typography
const { confirm } = Modal

const Courses = () => {
  const dispatch = useDispatch()

  const user = useSelector((state) => state.auth.user)

  useEffect(() => {
    if (user?.role === 'admin') {
      dispatch(getAllAdminCourses())
    } else {
      dispatch(getAllCourses())
    }
  }, [dispatch, user?.role])

  const courses = useSelector((state) =>
    state.courses.data.filter((course) => {
      return user?.role === 'admin' ? course : course.status !== 'archived'
    })
  )
  const loading = useSelector((state) => state.courses.loading)
  const history = useHistory()

  const [filter, setFilter] = useState('')

  const filteredCourses = courses?.filter((course) => {
    return user?.role === 'admin'
      ? course
      : user?.role === 'instructor'
      ? course?.createdBy?._id === user?._id &&
        course.name.toLowerCase().indexOf(filter.toLowerCase()) > -1
      : course.name.toLowerCase().indexOf(filter.toLowerCase()) > -1
  })

  const removeCourse = (courseId) => {
    dispatch(deleteCourse(courseId))
  }

  const handleEnroll = (courseId, userId) => {
    dispatch(enroll(courseId, userId))
  }

  const handleUnenroll = (courseId, userId) => {
    dispatch(unEnroll(courseId, userId))
  }

  const handleSearch = (value) => {
    setFilter(value)
  }

  const confirmEnrolled = function (courseId, userId) {
    confirm({
      title: 'Do you Want to enroll in this course?',
      icon: <ExclamationCircleOutlined />,
      content: 'You have to enroll in the course to view its content',
      onOk() {
        handleEnroll(courseId, userId)
      },
      onCancel() {
        return
      }
    })
  }

  const handleCourseCardClick = (courseId, userId, userEnrolled) => {
    if (userEnrolled && user?.role === 'student')
      history.push(`/app/course/${courseId}/modules`)
    else if (user?.role !== 'student' && user?.role === 'instructor')
      history.push(`/app/course/${courseId}/modules`)
    else if (user?.role === 'admin') history.push(`/app/course/${courseId}`)
    else confirmEnrolled(courseId, userId)
  }

  if (loading) return <Spinner size="large" />
  console.log(loading)

  return (
    <React.Fragment>
      <FlexSectionHeader>
        <Title level={3}>All Courses</Title>
        <Input.Search
          allowClear
          onSearch={handleSearch}
          placeholder="input search text"
          size="large"
          style={{ width: '300px', alignSelf: 'center' }}
        />
      </FlexSectionHeader>

      <div style={{ marginTop: '8px' }}>
        <Collapse
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
          defaultActiveKey={['1']}
          ghost
        >
          <Collapse.Panel header={<Text strong>Public Courses</Text>} key="1">
            <List
              grid={{
                gutter: 24,
                column: 3,
                xs: 1,
                sm: 2,
                xxl: 5
              }}
              dataSource={filteredCourses}
              renderItem={(course) => (
                <List.Item>
                  <CourseCard
                    course={course}
                    user={user}
                    removeCourse={() => removeCourse(course.id)}
                    handleEnroll={() => handleEnroll(course.id, user._id)}
                    handleUnenroll={() => handleUnenroll(course.id, user._id)}
                    onClick={() =>
                      handleCourseCardClick(
                        course.id,
                        user._id,
                        course.enrolled
                      )
                    }
                  />
                </List.Item>
              )}
            />
          </Collapse.Panel>
        </Collapse>
      </div>
    </React.Fragment>
  )
}

export default Courses
